import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-time-period-selector',
  templateUrl: './time-period-selector.component.html',
  styleUrls: ['./time-period-selector.component.css']
})
export class TimePeriodSelectorComponent implements OnInit {

  @Input() tabsDateRangeSelectedIndex: number = 1;
  @Input() showCustomDefined: Boolean = false;
  @Input() customDateFrom: Date;
  @Input() customDateTo: Date;

  @Output() changeDate = new EventEmitter<any>();
  @Output() rangeSelectedIndexChanged = new EventEmitter<number>();

  private selectedDate: any = moment();
  baseSizeCalendar = 320;
  tabsDateRange: any[];
  minZoomLevel: any = "decade";
  maxZoomLevel: any = "month";
  zoomLevel: any = "week";
  dateFrom: Date = new Date();
  dateTo: Date = new Date();
  momentDateFrom: any = moment();
  momentDateTo: any = moment();
  intervalSelected: boolean = false;
  periodText: string;

  labels = {
    period: this.ls.LNG('Label.Period'),
  }

  constructor(private ls: LanguageService) {
    this.tabsDateRange = [
      { id: 0, text: this.ls.LNG('Label.PreviousWeek') },
      { id: 1, text: this.ls.LNG('Label.PresentWeek') },
      { id: 2, text: this.ls.LNG('Label.PreviousMonth') },
      { id: 3, text: this.ls.LNG('Label.PresentMonth') },
    ];
  }

  ngOnInit(): void {
    if (this.showCustomDefined) {      
      this.tabsDateRange.push({ id: 4, text: this.ls.LNG('Label.Custom') });
      if (this.customDateFrom !== undefined && this.customDateFrom !== null) {
        this.dateFrom = this.customDateFrom;
      }
      if (this.customDateTo !== undefined && this.customDateTo !== null) {
        this.dateTo = this.customDateTo;
      }
    }
    
    this.setTabsDateRangeSelectedIndex();
    this.setDateText();
    this.setSelectedDate();
  }

  tabs_dateRange_onSelectionChanged(args: any) {
    this.tabsDateRangeSelectedIndex = args.addedItems[0].id;
    if (this.tabsDateRangeSelectedIndex === 4) {
      this.intervalSelected = true;
    }
    else {
      this.intervalSelected = false;
    }
    this.rangeSelectedIndexChanged.emit(this.tabsDateRangeSelectedIndex);
    this.setTabsDateRangeSelectedIndex();
  }

  setTabsDateRangeSelectedIndex() {
    switch (this.tabsDateRangeSelectedIndex) {
      case 0:
        this.intervalSelected = false;
        this.minZoomLevel = "decade";
        this.maxZoomLevel = "week";
        this.zoomLevel = "week";
        break;
      case 1:
        this.intervalSelected = false;
        this.minZoomLevel = "decade";
        this.maxZoomLevel = "week";
        this.zoomLevel = "week";
        break;
      case 2:
        this.intervalSelected = false;
        this.minZoomLevel = "decade";
        this.maxZoomLevel = "month";
        this.zoomLevel = "month";
        break;
      case 3:
        this.intervalSelected = false;
        this.minZoomLevel = "decade";
        this.maxZoomLevel = "month";
        this.zoomLevel = "month";
        break;      
      case 4:
        this.intervalSelected = true;
        break;
      default:
    }
    this.setDateText();
    this.setSelectedDate();
  }

  setDateText() {
    this.selectedDate = moment(Date.now());

    switch (this.tabsDateRangeSelectedIndex) {
      case 0:
        this.selectedDate = moment(this.selectedDate).subtract(1, 'week');
        let prevWeeknumber = moment(this.selectedDate).isoWeek();
        let prevWeekyear = moment(this.selectedDate).isoWeekYear();
        this.periodText = prevWeeknumber + "." + prevWeekyear;
        break;
      case 1:
        let presentWeeknumber = moment(Date.now()).isoWeek();
        let presentWeekyear = moment(Date.now()).isoWeekYear();
        this.periodText = presentWeeknumber + "." + presentWeekyear;
        break;
      case 2:
        this.selectedDate = moment(this.selectedDate).subtract(1, 'month');
        var nb = moment(this.selectedDate).locale('nb');//norwegian periodText
        let prevMonth = nb.format('MMMM');
        let prevMonthyear = moment(this.selectedDate).year();
        this.periodText = prevMonth + " " + prevMonthyear;
        break;
      case 3:
        var nb = moment(this.selectedDate).locale('nb');//norwegian periodText
        let presentMonth = nb.format('MMMM');
        let presentMonthyear = moment(this.selectedDate).year();
        this.periodText = presentMonth + " " + presentMonthyear;
        break;
      default:
    }
  }

  setSelectedDate() {
    switch (this.tabsDateRangeSelectedIndex) {
      case 0:
        this.momentDateFrom = moment(this.selectedDate).startOf('isoWeek').locale('nb');
        this.momentDateTo = moment(this.selectedDate).endOf('isoWeek').locale('nb');
        break;
      case 1:
        this.momentDateFrom = moment(this.selectedDate).startOf('isoWeek');
        this.momentDateTo = moment(this.selectedDate).endOf('isoWeek')
        break;
      case 2:
        this.momentDateFrom = moment(this.selectedDate).startOf('month');
        this.momentDateTo = moment(this.selectedDate).endOf('month');
        break;
      case 3:
        this.momentDateFrom = moment(this.selectedDate).startOf('month');
        this.momentDateTo = moment(this.selectedDate).endOf('month');
        break;
      case 4:
        this.momentDateFrom = moment(this.dateFrom);
        this.momentDateTo = moment(this.dateTo);
        break;
      default:
        this.momentDateFrom = moment(this.selectedDate).startOf('isoWeek');
        this.momentDateTo = moment(this.selectedDate).endOf('isoWeek')
        break;
    }

    this.changeDate.emit({
      FromDate: this.momentDateFrom,
      ToDate: this.momentDateTo,
      Zoomlevel: this.zoomLevel,
      PeriodText: this.periodText,
      SelectedIdx: this.tabsDateRangeSelectedIndex
    });
  }

  onValueChangedFrom(e: any) {
    this.setSelectedDate();
  }

  onValueChangedTo(e: any) {
    this.setSelectedDate();
  }

}
